module.exports = __webpack_public_path__ + "media/images/down_arrow-435dd885d24ee0e79db6f82a0de4f9a0.png";